export const CAMPAIGN_WORKSPACE_ASSETS = {
  analytics: '/assets/img/project-v2/analytics.png',
  campaignDriveDashboard: '/assets/img/project-v2/new-project.png',
  dashboard: '/assets/img/project-v2/workspace-img.png',
  timeline: '/assets/img/project-v2/timeline-header.png',
  ysl: '/assets/img/project-v2/ysl-dashboard.png',
  task_project: '/assets/img/project-v2/task-project-header.png',
  scenario2: '/assets/img/project-v2/scenario2Dashboard.png',
  scenario4ysl: '/assets/img/project-v2/scenario4yslheader.png',
  skinCare3: '/assets/img/project-v2/hr/skin-care-3.png',
};

export const WORKSPACE_DASHBOARD_ASSETS = {
  DEFAULT_HEADER_IMAGE: '/assets/img/project-v2/workspace-image.png',
};
